import React from 'react';
import { READING, ESPANOL } from '../../constants/applications';
import { SPANISH, ENGLISH } from '../../constants/languages';

export const LanguageContext = React.createContext(ENGLISH);
LanguageContext.displayName = 'LanguageContext';

export const useLanguageContext = () => React.useContext(LanguageContext);

export const getLanguage = appGroup => {
    if (appGroup === READING) {
        return ENGLISH;
    }
    if (appGroup === ESPANOL) {
        return SPANISH;
    }
    return ENGLISH;
};

export default LanguageContext;
